import { generatePath, useLoaderData, useLocation } from 'react-router';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { devicesMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n';
import { getSubscriptionBreadcrumbName, getSubscriptionUrlId } from '../../../../../common/utils/subscriptionUtils.js';
import { AddonDetails } from '../../../../../components/AddonDetails/AddonDetails.js';
import { BreadCrumbs } from '../../../../../components/BreadCrumbs';
import type { SubscriptionAddOnLoaderResponse } from '../../../../../common/loaders.js';

export const DeviceAddOnPath = () => {
  const { search } = useLocation();
  const { addOn, hasPendingActions, subscription } = useLoaderData() as SubscriptionAddOnLoaderResponse;

  return (
    <AddonDetails
      addOn={addOn}
      breadCrumbs={
        <BreadCrumbs
          breadCrumbPaths={[
            { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
            { name: t.JJTM(devicesMsg), path: paths.PS_DEVICES },
            {
              name: getSubscriptionBreadcrumbName(subscription),
              path: generatePath(paths.PS_DEVICE, { subscriptionId: getSubscriptionUrlId(subscription) }) + search,
            },
            { name: addOn?.addOnProductName || '...' },
          ]}
        />
      }
      subscription={subscription}
      hasPendingActions={hasPendingActions}
      subscriptionPath={paths.PS_DEVICE}
    />
  );
};
